import { render, staticRenderFns } from "./OfficePos.vue?vue&type=template&id=74a7b554&"
import script from "./OfficePos.vue?vue&type=script&lang=js&"
export * from "./OfficePos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports